var map = {
	"./brand-logo.svg": 7603,
	"./brokenleg-icon.svg": 9515,
	"./icon-bandage.svg": 8836,
	"./icon-brokenleg.svg": 5363,
	"./icon-oldman.svg": 7911,
	"./icon-piggy.svg": 8846,
	"./ideal.svg": 9585,
	"./logo-zelfstandig-ondernemers.svg": 2892,
	"./new.svg": 7932,
	"./nieuw.svg": 6758,
	"./products_white_blue.svg": 4379,
	"./quad_products.svg": 2410,
	"./quad_products_black.svg": 6822,
	"./update.svg": 9350
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2282;